var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgUser = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M2.667 14.667a5.333 5.333 0 0 1 10.666 0H12a4 4 0 0 0-8 0H2.667Zm5.333-6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-1.333A2.666 2.666 0 1 0 8 2a2.666 2.666 0 1 0 0 5.334Z", fill: "#61605F" }));
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIuNjY3IDE0LjY2N2E1LjMzMyA1LjMzMyAwIDAgMSAxMC42NjYgMEgxMmE0IDQgMCAwIDAtOCAwSDIuNjY3Wm01LjMzMy02Yy0yLjIxIDAtNC0xLjc5LTQtNHMxLjc5LTQgNC00IDQgMS43OSA0IDQtMS43OSA0LTQgNFptMC0xLjMzM0EyLjY2NiAyLjY2NiAwIDEgMCA4IDJhMi42NjYgMi42NjYgMCAxIDAgMCA1LjMzNFoiIGZpbGw9IiM2MTYwNUYiLz48L3N2Zz4=";
